module.exports = __webpack_public_path__ + "static/media/sad-tear-regular.013a4cc7.svg";